import React from "react";
import { List } from "@mui/material";
import MessagePreviewItem from "./MessagePreviewItem";

const MessagesList = ({
  messagePreviews,
  onSelectChat,
  openChatId,
  recentlyReadChats,
  externalNotificationRefetch,
  userId,
  updateParticipantMutation,
  refetchPreviews,
  selectedTeamMemberId,
}) => {
  if (!messagePreviews) messagePreviews = [];

  return (
    <List sx={{ width: "100%", padding: 0 }}>
      {messagePreviews.map((preview) => (
        <MessagePreviewItem
          key={preview.chat_id}
          preview={preview}
          onSelectChat={onSelectChat}
          openChatId={openChatId}
          recentlyReadChats={recentlyReadChats}
          externalNotificationRefetch={externalNotificationRefetch}
          updateParticipantMutation={updateParticipantMutation}
          userId={userId}
          refetchPreviews={refetchPreviews}
          selectedTeamMemberId={selectedTeamMemberId}
        />
      ))}
    </List>
  );
};

export default MessagesList;
